import { useEffect, useState } from 'react';
import Modal from '../Modal';
import EventTypeCheckboxes from '../EventTypeCheckboxes.jsx';
import ErrorMessage from '../ErrorMessage';

const NewAvailabilityGroupModal = ({
    isOpen,
    onClose,
    onSave,
    isSaving,
}) => {
    const [selectedEventTypes, setSelectedEventTypes] = useState([]);
    const [showError, setShowError] = useState(false);

    // Reset state when modal opens
    useEffect(() => {
        if (isOpen) {
            setSelectedEventTypes([]);
            setShowError(false);
        }
    }, [isOpen]);

    const handleSave = () => {
        if (selectedEventTypes.length === 0) {
            setShowError(true);
            return;
        }

        onSave(selectedEventTypes);
    };

    const handleClose = () => {
        setSelectedEventTypes([]);
        setShowError(false);
        onClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleClose}
            widthClass="sm:max-w-[500px]"
        >
            <h2 className="mb-4">Availability Group</h2>
            <p className="text-gray-500 leading-tight mb-4">
                Choose which event types you would like to set different
                availability for
            </p>
            <div className="mb-6">
                <EventTypeCheckboxes
                    id="new-group-event-types"
                    value={selectedEventTypes}
                    onChange={setSelectedEventTypes}
                    excludeClasses={true}
                />
            </div>
            {selectedEventTypes.length === 0 && showError && (
                <ErrorMessage className="mb-4">
                    Please select the event types you want to set different
                    availability for
                </ErrorMessage>
            )}
            <div className="flex gap-x-4">
                <button
                    className="btn-save"
                    onClick={handleSave}
                    disabled={isSaving}
                >
                    {isSaving ? 'Creating...' : 'Create Group'}
                </button>
                <button
                    className="btn-light-pill-lg"
                    onClick={handleClose}
                >
                    Cancel
                </button>
            </div>
        </Modal>
    );
};

export default NewAvailabilityGroupModal;

